// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Queue_wrapper__3txFr"};